import { ThemeColors } from 'styled-components';
import styled from 'styled-components';

interface TextProps {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label';
    light?: boolean;
    large?: boolean;
    small?: boolean;
    pointer?: boolean;
    color?: keyof ThemeColors;
    underline?: boolean;
    strike?: boolean;
    fontSize?: number;
    uppercase?: boolean;
    textOverflow?: string;
    center?: boolean;
    bold?: boolean;
    xBold?: boolean;
    nowrap?: boolean;
    className?: string;
    lineheight?: number;
    thin?: boolean;
    italic?: boolean;
    margin?: number | string;
    padding?: number | string;
}

const Text = styled.div.attrs<TextProps>(({ as = 'p' }) => ({
    as,
}))<TextProps>`
  
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'pre-line')};
  font-size: ${({ large, small, theme }) => (large ? '16px' : small ? '12px' : theme.typography.fontSize)};
  color: ${({ light, theme }) => (light ? theme.colors.textLight : theme.colors.text)};

  ${({ italic }) => italic && 'font-style: italic;'};
  ${({ margin }) =>
      margin !== undefined && `margin: ${typeof margin === 'number' ? `${margin}rem` : margin} !important;`};
  ${({ padding }) =>
      padding !== undefined && `padding: ${typeof padding === 'number' ? `${padding}rem` : padding} !important;`};
  
  ${({ theme, color }) => color && `color: ${theme.colors[color]};`}
  ${({ bold }) => bold && 'font-weight: 500;'}
  ${({ xBold }) => xBold && 'font-weight: 700;'}
  ${({ thin }) => thin && 'font-weight: 300;'}
  ${({ underline }) => underline && 'text-decoration: underline;'}
  ${({ strike }) => strike && 'text-decoration: line-through;'}
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
  ${({ lineheight }) => lineheight && `line-height: ${lineheight}px;`}
  ${({ pointer }) => pointer && 'cursor: pointer;'}
  ${({ uppercase }) => uppercase && 'text-transform: uppercase;'}
  ${({ center }) => center && 'text-align: center;'}
  ${({ textOverflow }) =>
      textOverflow &&
      `
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: ${textOverflow}px;
    `}
`;

export const TextBox = styled(Text)`
    background-color: ${({ theme }) => theme.colors.fill};
    padding: 10px 15px;
`;

export default Text;
